import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import OpenMoji from '@gik/ui/OpenMoji';
import { HTMLParser } from '@gik/ui';
import ReactDOM from 'react-dom';

export interface IOAuthErrorProps {
  oauthErrorMessage?: string;
  buttonsPortal?: () => HTMLElement;
  errorMessageButtons?: JSX.Element;
}

const blockName = 'oauth-error-modal-content';

export default function OAuthErrorModalContent({
  oauthErrorMessage,
  buttonsPortal,
  errorMessageButtons,
}: IOAuthErrorProps) {
  const bem = bemBlock(blockName);

  return (
    <>
      {oauthErrorMessage && (
        <section className={bem('oauth-error-message')}>
          <header className="login-image-container">
            <OpenMoji name="thinking-face" />
            <span>hmmm...</span>
          </header>
          <p>
            <HTMLParser rawHtml={oauthErrorMessage} />
          </p>

          {buttonsPortal && buttonsPortal() && ReactDOM.createPortal(errorMessageButtons, buttonsPortal())}
          {!buttonsPortal && errorMessageButtons}
        </section>
      )}
    </>
  );
}
